import axios from "axios";
import { NotThirdPartyService } from "./service";
import { keycloak } from "../../../../../lib/keycloak";
import { filtersDTO, NotThirdPartyResponseDTO, NotThirdPartyDataDTO, NotThirdPartyProcessingDataDTO, NotThirdPartyProcessingResponseDTO, NotThirdPartyStructureResponseDTO, NotThirdPartyProcessingCreateDTO } from "./dto";

export class NotProductiveUnitImpl implements NotThirdPartyService {

    public GetAllNotThirdParty(filters: filtersDTO): Promise<NotThirdPartyResponseDTO> {
        return axios.get("/api/third-party-notification", {
            params: {
                itemsPerPage: filters.itemsPerPage,
                page: filters.page ? filters.page : 0,
                notificationId: filters.notificationId
            },
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }

    public GetAllNotThirdPartyProcessing(filters: filtersDTO): Promise<NotThirdPartyProcessingResponseDTO> {
        return axios.get("/api/third-party-processing", {
            params: {
                itemsPerPage: filters.itemsPerPage,
                page: filters.page ? filters.page : 0,
                notificationId: filters.notificationId
            },
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }

    public GetAllNotThirdPartyStructure(filters: filtersDTO): Promise<NotThirdPartyStructureResponseDTO> {
        return axios.get("/api/third-party-structure", {
            params: {
                itemsPerPage: filters.itemsPerPage,
                page: filters.page ? filters.page : 0,
                notificationId: filters.notificationId
            },
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }

    public CreateProcessing(data: NotThirdPartyProcessingCreateDTO): Promise<void> {
        return axios.post("/api/third-party-processing",
            data,
            {
                headers: {
                    Authorization: 'Bearer ' + keycloak.token,
                    Accept: '*/*',
                    'Content-Type': 'application/json'
                }
            }
        ).then((response) => response.data);
    }
}